const MAX_METRO_DISTANCE_MILES = 50;

// Stable metro anchors keep Apple's municipality-level results useful on the
// public site. The closest anchor wins when metro areas overlap.
const METRO_CITIES = [
  ["Portland", "Maine", 43.6591, -70.2568],
  ["Boston", "Massachusetts", 42.3601, -71.0589],
  ["Providence", "Rhode Island", 41.8240, -71.4128],
  ["Hartford", "Connecticut", 41.7658, -72.6734],
  ["Worcester", "Massachusetts", 42.2626, -71.8023],
  ["Albany", "New York", 42.6526, -73.7562],
  ["New York City", "New York", 40.7128, -74.0060],
  ["Philadelphia", "Pennsylvania", 39.9526, -75.1652],
  ["Baltimore", "Maryland", 39.2904, -76.6122],
  ["Washington", "District of Columbia", 38.9072, -77.0369],
  ["Pittsburgh", "Pennsylvania", 40.4406, -79.9959],
  ["Buffalo", "New York", 42.8864, -78.8784],
  ["Cleveland", "Ohio", 41.4993, -81.6944],
  ["Columbus", "Ohio", 39.9612, -82.9988],
  ["Cincinnati", "Ohio", 39.1031, -84.5120],
  ["Detroit", "Michigan", 42.3314, -83.0458],
  ["Indianapolis", "Indiana", 39.7684, -86.1581],
  ["Chicago", "Illinois", 41.8781, -87.6298],
  ["Milwaukee", "Wisconsin", 43.0389, -87.9065],
  ["Minneapolis", "Minnesota", 44.9778, -93.2650],
  ["St. Louis", "Missouri", 38.6270, -90.1994],
  ["Kansas City", "Missouri", 39.0997, -94.5786],
  ["Omaha", "Nebraska", 41.2565, -95.9345],
  ["Louisville", "Kentucky", 38.2527, -85.7585],
  ["Nashville", "Tennessee", 36.1627, -86.7816],
  ["Richmond", "Virginia", 37.5407, -77.4360],
  ["Virginia Beach", "Virginia", 36.8529, -75.9780],
  ["Raleigh", "North Carolina", 35.7796, -78.6382],
  ["Charlotte", "North Carolina", 35.2271, -80.8431],
  ["Charleston", "South Carolina", 32.7765, -79.9311],
  ["Atlanta", "Georgia", 33.7490, -84.3880],
  ["Jacksonville", "Florida", 30.3322, -81.6557],
  ["Orlando", "Florida", 28.5383, -81.3792],
  ["Tampa", "Florida", 27.9506, -82.4572],
  ["Miami", "Florida", 25.7617, -80.1918],
  ["New Orleans", "Louisiana", 29.9511, -90.0715],
  ["Dallas", "Texas", 32.7767, -96.7970],
  ["Austin", "Texas", 30.2672, -97.7431],
  ["San Antonio", "Texas", 29.4241, -98.4936],
  ["Houston", "Texas", 29.7604, -95.3698],
  ["Oklahoma City", "Oklahoma", 35.4676, -97.5164],
  ["Denver", "Colorado", 39.7392, -104.9903],
  ["Salt Lake City", "Utah", 40.7608, -111.8910],
  ["Phoenix", "Arizona", 33.4484, -112.0740],
  ["Tucson", "Arizona", 32.2226, -110.9747],
  ["Las Vegas", "Nevada", 36.1699, -115.1398],
  ["Boise", "Idaho", 43.6150, -116.2023],
  ["Seattle", "Washington", 47.6062, -122.3321],
  ["Portland", "Oregon", 45.5152, -122.6784],
  ["Sacramento", "California", 38.5816, -121.4944],
  ["San Francisco", "California", 37.7749, -122.4194],
  ["San Jose", "California", 37.3382, -121.8863],
  ["Los Angeles", "California", 34.0522, -118.2437],
  ["San Diego", "California", 32.7157, -117.1611],
  ["Honolulu", "Hawaii", 21.3069, -157.8583],
  ["Anchorage", "Alaska", 61.2181, -149.9003],
].map(([city, region, latitude, longitude]) => ({ city, region, latitude, longitude, countryCode: "US" }));

function distanceMiles(from, to) {
  const radians = (degrees) => degrees * Math.PI / 180;
  const latitudeDelta = radians(to.latitude - from.latitude);
  const longitudeDelta = radians(to.longitude - from.longitude);
  const fromLatitude = radians(from.latitude);
  const toLatitude = radians(to.latitude);
  const haversine = Math.sin(latitudeDelta / 2) ** 2
    + Math.cos(fromLatitude) * Math.cos(toLatitude) * Math.sin(longitudeDelta / 2) ** 2;
  return 3958.7613 * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
}

export function publicCity(location) {
  if (!location || location.status !== "published") return location;
  const { latitude, longitude } = location;
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return location;
  const closest = METRO_CITIES
    .filter((candidate) => candidate.countryCode === location.countryCode)
    .map((candidate) => ({ candidate, miles: distanceMiles(location, candidate) }))
    .sort((a, b) => a.miles - b.miles)[0];
  if (!closest || closest.miles >= MAX_METRO_DISTANCE_MILES) return location;
  const { city, region } = closest.candidate;
  return {
    ...location,
    city,
    region,
    latitude: Math.round(closest.candidate.latitude * 10) / 10,
    longitude: Math.round(closest.candidate.longitude * 10) / 10,
  };
}
